import { useState } from "react";
import urlToId from "../../../../../helpers/UrlToId";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from "@chakra-ui/react";
import TaskTypeSelect from "../../../../../shared/components/IssueTypeSelect";
import client from "../../../../../helpers/Client";
import SaveButton from "../../../../../components/buttons/SaveButton";

export default function AssingTaskTypeModal({ task, revalidator, state }) {
  const [type, setType] = useState(null);
  const toast = useToast();
  const handleSubmit = () => {
    const taskId = urlToId(task.url);
    client
      .patch(`/tasks/${taskId}/`, {
        kind: type,
      })
      .then(() => {
        toast({
          title: "Alt görev tipi değiştirildi",
          status: "success",
        });
        revalidator.revalidate();
        state.onClose();
      })
      .catch((error) => {
        Object.values(error.response.data).forEach((value) => {
          toast({
            title: "İşlem gerçekleştirilemiyor: " + value,
            status: "error",
          });
        });
      });
  };

  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Alt Görev Tipi Seç</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TaskTypeSelect task={task} onChange={setType} />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={state.onClose}>
            Vazgeç
          </Button>
          <SaveButton onClick={handleSubmit}>Kaydet</SaveButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
